import React from "react";

export const AdvancedOptionsPanel = ({ title = "Advanced Options", children }) => (
  <section className="advanced-options-panel">
    <h3>{title}</h3>
    {children}
  </section>
);

export const AssumptionsPanel = ({ assumptions = [] }) => {
  if (!assumptions.length) return null;
  return (
    <section className="calculator-result-card advanced-info-panel">
      <span className="calculator-result-label">Assumptions</span>
      <ul>
        {assumptions.map((item) => <li key={item}>{item}</li>)}
      </ul>
    </section>
  );
};

export const CalculationTracePanel = ({ trace = [] }) => {
  if (!trace.length) return null;
  return (
    <section className="calculator-result-card advanced-info-panel">
      <span className="calculator-result-label">Calculation Trace</span>
      <ul>
        {trace.map((item) => <li key={item}>{item}</li>)}
      </ul>
    </section>
  );
};

export const ShopNotesPanel = ({ notes = [] }) => {
  if (!notes.length) return null;
  return (
    <section className="calculator-result-card advanced-info-panel">
      <span className="calculator-result-label">What this means in the shop</span>
      <ul>
        {notes.map((item) => <li key={item}>{item}</li>)}
      </ul>
    </section>
  );
};
